// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { Navigate } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "src/contexts/user-context";
import { useSpaceContext } from "src/components/spaces";
import { homeRoute } from "./constants";

export const RootIndex = () => {
  const { user, slug, isOnboarding, isLoading } = useUser();
  const { partnerUser } = useFlags();
  const { isInSpace } = useSpaceContext();

  // Wait for the user query to resolve before deciding where to redirect.
  // Without this, a cold load sees `user` undefined and bounces to /signup,
  // then back once the query resolves. Render nothing — the static index.html
  // skeleton covers this window until loading finishes.
  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate replace to="/signup" />;
  }

  if (!slug) {
    if (partnerUser) {
      return <Navigate replace to="/partner" />;
    }
    return <Navigate replace to="/workspaces" />;
  }

  // Space-scoped users should be redirected to audiences instead of home
  if (isInSpace) {
    return <Navigate replace to={`/${slug}/audiences`} />;
  }

  if (isOnboarding) {
    return <Navigate replace to={`/${slug}/onboarding`} />;
  }

  return <Navigate replace to={`/${slug}${homeRoute}`} />;
};
